const UNITS = [
    [86400, 'д'],
    [3600, 'ч'],
    [60, 'мин'],
    [1, 'сек'],
];
/** Seconds as «1 ч 30 мин»: exact, largest units first, empty ones skipped. */
export function durationText(seconds) {
    let rest = Math.max(0, Math.floor(seconds));
    if (rest === 0)
        return '0 сек';
    const parts = [];
    for (const [size, unit] of UNITS) {
        const n = Math.floor(rest / size);
        if (n > 0)
            parts.push(`${n} ${unit}`);
        rest -= n * size;
    }
    return parts.join(' ');
}
